const createGeometryRectangle = ({
  x,
  y,
  width,
  height,
  ProjectCode = null,
  SiteCode = null,
  AssetCode = null,
  LevelCode = null,
}) => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);

    return {
    InterfaceID: `interface_${timestamp}_${random}`,
    InterfaceCode: `INTF_RECT_${timestamp}_${random}`,
    InterfaceName: "",
    InterfaceType: "RECTANGLE",

    ProjectCode,
    SiteCode,
    AssetCode,
    LevelCode,

    GeometryType: "RECT",
    GeometryData: {
      x,
      y,
      width,
      height,
    },

    IsActive: true,
  };
};

export default createGeometryRectangle;